(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-case-type-attribute', {
            parent: 'entity',
            url: '/custom-case-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ],
                pageTitle: 'trakeyeApp.customCaseTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attributes.html',
                    controller: 'CustomCaseTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customCaseTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-case-type-attribute-detail', {
            parent: 'custom-case-type-attribute',
            url: '/custom-case-type-attribute/{id}',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ],
                pageTitle: 'trakeyeApp.customCaseTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attribute-detail.html',
                    controller: 'CustomCaseTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customCaseTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomCaseTypeAttribute', function($stateParams, CustomCaseTypeAttribute) {
                    return CustomCaseTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-case-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        /*.state('custom-case-type-attribute-detail.edit', {
            parent: 'custom-case-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attribute-dialog.html',
                    controller: 'CustomCaseTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomCaseTypeAttribute', function(CustomCaseTypeAttribute) {
                            return CustomCaseTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
        /*.state('custom-case-type-attribute.new', {
            parent: 'custom-case-type-attribute',
            url: '/new',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attribute-dialog.html',
                    controller: 'CustomCaseTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-case-type-attribute', null, { reload: 'custom-case-type-attribute' });
                }, function() {
                    $state.go('custom-case-type-attribute');
                });
            }]
        })*/
        
        .state('custom-case-type-attribute.new', {
			parent : 'custom-case-type-attribute',
			url : '/new',
			data : {
				authorities : [ 'ROLE_USER_ADMIN' ]
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attribute-dialog.html',
                    controller: 'CustomCaseTypeAttributeDialogController',
                    controllerAs: 'vm',
				}
			},
			resolve : {
				entity : function() {
					return {
						name : null,
						description : null,
						id : null
					};
				}
			}
		})
        /*.state('custom-case-type-attribute.edit', {
            parent: 'custom-case-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attribute-dialog.html',
                    controller: 'CustomCaseTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomCaseTypeAttribute', function(CustomCaseTypeAttribute) {
                            return CustomCaseTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-case-type-attribute', null, { reload: 'custom-case-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
		
		.state('custom-case-type-attribute.edit', {
			parent : 'custom-case-type-attribute',
			url : '/{id}/edit',
			data : {
				authorities : [ 'ROLE_USER_ADMIN' ],
				pageTitle : 'trakeyeApp.customCaseTypeAttribute.home.title'
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attribute-dialog.html',
                    controller: 'CustomCaseTypeAttributeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('customCaseTypeAttribute');
					return $translate.refresh();
				} ],
				entity : [ '$stateParams', 'CustomCaseTypeAttribute', function($stateParams, CustomCaseTypeAttribute) {
					return CustomCaseTypeAttribute.get({
						id : $stateParams.id
					}).$promise;
				} ],
				previousState : [ "$state", function($state) {
					var currentStateData = {
						name : $state.current.name || 'custom-case-type-attribute',
						params : $state.params,
						url : $state.href($state.current.name, $state.params)
					};
					return currentStateData;
				} ]
			}
		})
        .state('custom-case-type-attribute.delete', {
            parent: 'custom-case-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attribute-delete-dialog.html',
                    controller: 'CustomCaseTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomCaseTypeAttribute', function(CustomCaseTypeAttribute) {
                            return CustomCaseTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-case-type-attribute', null, { reload: 'custom-case-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();


/*(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-case-type-attribute', {
            parent: 'entity',
            url: '/custom-case-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ],
                pageTitle: 'trakeyeApp.customCaseTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attributes.html',
                    controller: 'CustomCaseTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customCaseTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-case-type-attribute-detail', {
            parent: 'custom-case-type-attribute',
            url: '/custom-case-type-attribute/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'trakeyeApp.customCaseTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attribute-detail.html',
                    controller: 'CustomCaseTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customCaseTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomCaseTypeAttribute', function($stateParams, CustomCaseTypeAttribute) {
                    return CustomCaseTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-case-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('custom-case-type-attribute-detail.edit', {
            parent: 'custom-case-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attribute-dialog.html',
                    controller: 'CustomCaseTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomCaseTypeAttribute', function(CustomCaseTypeAttribute) {
                            return CustomCaseTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-case-type-attribute.new', {
            parent: 'custom-case-type-attribute',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attribute-dialog.html',
                    controller: 'CustomCaseTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-case-type-attribute', null, { reload: 'custom-case-type-attribute' });
                }, function() {
                    $state.go('custom-case-type-attribute');
                });
            }]
        })
        .state('custom-case-type-attribute.edit', {
            parent: 'custom-case-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attribute-dialog.html',
                    controller: 'CustomCaseTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomCaseTypeAttribute', function(CustomCaseTypeAttribute) {
                            return CustomCaseTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-case-type-attribute', null, { reload: 'custom-case-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-case-type-attribute.delete', {
            parent: 'custom-case-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-case-type-attribute/custom-case-type-attribute-delete-dialog.html',
                    controller: 'CustomCaseTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomCaseTypeAttribute', function(CustomCaseTypeAttribute) {
                            return CustomCaseTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-case-type-attribute', null, { reload: 'custom-case-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();*/
